




















import Vue, { PropType } from 'vue'
import BaseButton from '@/ui/button/BaseButton.vue'
import { TableField } from '@/pages/dictionary/themes/list/types'
import HeaderPopup from '@/pages/common/parts/header/header-popup/HeaderPopup.vue'
import DownloadButton from '@/pages/common/parts/header/DownloadButton.vue'
import { $permissions } from '@/features/session'

export default Vue.extend({
  name: 'PageHeader',
  effector: {
    $permissions,
  },
  components: {
    BaseButton,
    HeaderPopup,
    DownloadButton,
  },
  props: {
    tableColumns: { type: Array as PropType<TableField[]> },
  },
})
